import React from "react";
import { Stack } from "expo-router/stack";

import FollowerHeader from "@/Components/Headers/FollowerHeader";
import FollowingHeader from "@/Components/Headers/FollowingHeader";
import { useSession } from "@/context/auth/useSession";
import LoadingScreen from "@/screens/Loading/LoadingScreen";
import UserNotificationsHeader from "@/screens/Notification/UserNotificationsHeader";

export default function Layout(): React.JSX.Element {
  const { session } = useSession();

  if (session === null) {
    return <LoadingScreen />;
  }

  return (
    <Stack>
      <Stack.Screen
        name="profile"
        options={{
          headerShown: false,
        }}
      />
      <Stack.Screen
        name="followers"
        options={{
          header: () => {
            return <FollowerHeader />;
          },
        }}
      />
      <Stack.Screen
        name="followings"
        options={{
          header: () => {
            return <FollowingHeader />;
          },
        }}
      />
      <Stack.Screen
        name="image"
        options={{
          headerShown: false,
        }}
      />
      <Stack.Screen
        name="user-notifications"
        options={{
          header: () => {
            return <UserNotificationsHeader />;
          },
        }}
      />
      <Stack.Screen
        name="onboarding"
        options={{
          headerShown: false,
        }}
      />
    </Stack>
  );
}
